import React from 'react';
import { Link } from 'react-router-dom';
import '../../CSS/EmpoweringLead.css';

const EmpoweringLead: React.FC = () => {
  const desktopImagePath = '/assets/Web Version/Our Success Stories/empowering-universities-success-story-image.png';
  const mobileImagePath = '/assets/Web Version/Our Success Stories/mobile/empowering-universities-success-story-image-mob.png';
  
  return (
    <div className="empowering-lead-page">
      <div className="empowering-lead-hero-banner">
        <div 
          className="empowering-lead-hero-background"
          style={{ 
            backgroundImage: `url("${desktopImagePath}")` 
          }}
        ></div>
        <div 
          className="empowering-lead-hero-background-mobile"
          style={{ 
            backgroundImage: `url("${mobileImagePath}")` 
          }}
        ></div>
        <div className="empowering-lead-hero-content">
          <div className="empowering-lead-breadcrumb">
            <Link to="/">Home</Link>
            <span className="breadcrumb-separator">/</span>
            <Link to="/news-and-insights">News & Insights</Link>
            <span className="breadcrumb-separator">/</span>
            <Link to="/news-and-insights/our-success-stories">Our Success Stories</Link>
          </div>
          <h1 className="empowering-lead-title">
            Empowering a Leading U.S. University with an Industry-Driven AI Lab
          </h1>
        </div>
      </div>

      {/* Content Sections */}
      <div className="empowering-lead-content">
        {/* Overview Section */}
        <div className="empowering-lead-section">
          <h2 className="empowering-lead-section-title">Overview</h2>
          <p className="empowering-lead-section-text">
            Our partnership with a world-class U.S. research institution led to the creation of a state-of-the-art <strong>Artificial Intelligence (AI) Lab</strong>, designed to merge academic research with industry priorities. Together, we built an environment that fosters AI innovation, applied learning, and commercialization of cutting-edge discoveries.
          </p>
        </div>

        {/* Objective Section */}
        <div className="empowering-lead-section">
          <h2 className="empowering-lead-section-title">Objective</h2>
          <p className="empowering-lead-section-text">
            To create a sustainable and scalable AI Lab that enhances research capability, strengthens university–industry collaboration, and delivers AI-based solutions across <strong>healthcare, logistics, and retail</strong>.
          </p>
        </div>

        {/* Execution Section */}
        <div className="empowering-lead-section">
          <h2 className="empowering-lead-section-title">Execution</h2>
          <p className="empowering-lead-section-text">
            We led the full cycle of AI Lab establishment:
          </p>
          <ul className="empowering-lead-list">
            <li><strong>Strategic Planning:</strong> Formed a multi-stakeholder AI Lab Consortium defining roles, governance, and functional objectives.</li>
            <li><strong>Budgeting & Compliance:</strong> Developed operating models, funding projections, and comprehensive compliance frameworks.</li>
            <li><strong>Infrastructure & Operations:</strong> Managed recruitment, infrastructure (hardware, software, data center), and university-wide communications for launch.</li>
            <li><strong>Knowledge Enablement:</strong> Delivered enterprise knowledge consultation, technical and customer support, and product management training.</li>
          </ul>
        </div>

        {/* Key Achievements Section */}
        <div className="empowering-lead-section">
          <h2 className="empowering-lead-section-title">Key Achievements</h2>
          <ul className="empowering-lead-list">
            <li>Built a fully functional <strong>AI Product Hub</strong>, enabling collaboration between academic researchers and industry leaders.</li>
            <li>Launched <strong>AI-focused academic programs and capstone projects</strong>, giving students hands-on exposure to real-world AI challenges.</li>
            <li>Established a <strong>career-enabling ecosystem</strong>, allowing companies to engage directly with trained AI talent.</li>
            <li>Delivered the <strong>ImageIQ Clinical Imaging Tool</strong>, developed in collaboration with the <strong>University of Kentucky</strong> and <strong>Johns Hopkins University</strong>—enhancing CT lung image quality and diagnostic precision.</li>
          </ul>
        </div>

        {/* Impact Section */}
        <div className="empowering-lead-section">
          <h2 className="empowering-lead-section-title">Impact</h2>
          <p className="empowering-lead-section-text">
            This initiative:
          </p>
          <ul className="empowering-lead-list">
            <li>Strengthened the university's research–industry partnerships.</li>
            <li>Accelerated AI innovation from concept to commercialization.</li>
            <li>Provided a scalable blueprint for other academic institutions aiming to operationalize AI excellence.</li>
          </ul>
        </div>
      </div>

      {/* Looking Ahead Section */}
      <div className="looking-ahead">
        <h2 className="looking-ahead-title">Looking Ahead</h2>
        <p className="looking-ahead-description">
          Following this success, we are extending the <strong>AI Lab Consortium</strong> model to additional universities—creating a nationwide network that fosters AI research, education, and real-world transformation.
        </p>
      </div>
    </div>
  );
};

export default EmpoweringLead;

